import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiButton, TuiIcon } from '@taiga-ui/core';
import { NetworkConnectivityService } from '../../services/network-connectivity.service';

@Component({
  selector: 'app-network-status-banner',
  standalone: true,
  imports: [TuiButton, TuiIcon],
  templateUrl: './network-status-banner.html',
  styleUrl: './network-status-banner.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NetworkStatusBannerComponent {
  private readonly connectivity = inject(NetworkConnectivityService);

  showBanner = this.connectivity.showBanner;
  bannerMessage = this.connectivity.bannerMessage;
  bannerSeverity = this.connectivity.bannerSeverity;

  recheckConnection(): void {
    this.connectivity.recheckConnection();
  }
}
